import { Dialog, styled } from '@mui/material';

export const ConfirmDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialog-paper': {
    width: 479,
    maxWidth: '90vw',
    margin: theme.spacing(2),
    padding: theme.spacing(3),
    borderRadius: 6,
  },
}));
